module.exports = __webpack_public_path__ + "img/phoi-sim-1.6347ff49.svg";